// Smooth in-page scrolling that leaves room for the sticky header. Shared by
// the course search filter button (course_search_controller.js) and in-page
// anchor links (scroll_to_controller.js).

// room kept free above the target for the sticky header
const HEADER_OFFSET = 150;

export function scrollBelowHeader(element) {
  const top = element.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
  window.scrollTo({ top: top, behavior: "smooth" });
}
